import { render, staticRenderFns } from "./PortalUpdateStepImages.vue?vue&type=template&id=9532ff04&scoped=true"
import script from "./PortalUpdateStepImages.vue?vue&type=script&lang=js"
export * from "./PortalUpdateStepImages.vue?vue&type=script&lang=js"
import style0 from "./PortalUpdateStepImages.vue?vue&type=style&index=0&id=9532ff04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9532ff04",
  null
  
)

export default component.exports